import React from 'react';
import Helmet from 'react-helmet';

const Block = ({ image, paragraphs }) => (
  <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 55 }}>
    <div style={{ paddingRight: 25 }}><img src={image} /></div>
    <div>{paragraphs}</div>
  </div>
);

const About = () => (
  <div style={{ padding: 50, textAlign: 'left', maxWidth: 800, margin: '0 auto' }}>
    <Helmet title="Bumbloods | About" />
    <h1 style={{ textAlign: 'center' }}>About Bumbloods</h1>
    <Block
      image="/glasses.jpg"
      paragraphs="Bumbloods is a four part miniseries about two unlikely roommates trying to survive during a zombie apocalypse. When a new, synthetic drug hits the streets, 90% of the human population is suddenly transformed into flesh eating zombies. Dr. Jeremy &quot;JERMS&quot; Madison and his roommate Mario &quot;KREPE&quot; Krepeli find themselves in the middle of a zombie infested world and this &quot;odd couple&quot; must learn to cohabitate despite their differences and the ever growing horde of undead around them."
    />

    <h2 style={{ textAlign: 'center' }}>Dr. Jeremy "JERMS" Madison</h2>
    <Block
      image="/jerms.jpg"
      paragraphs="Born and raised in Peoria, Illinois. He is currently doing his residency at Beth Israel Memorial Hospital. He’s been working in the ER for a little over a year, and thinks he’s seen the worst of what can happen to people. Time will prove him wrong. He moved to New York City with his longtime girlfriend, Grace. They don’t live together, though... not until he puts a ring on her finger. Jerms met his future roommate, Steve, while treating him for dehydration after he partied a little too hard at a rave. At the time, Jerms was couch hopping, but soon after, moved in with Steve. There turned out to a third roommate, Mario ”KREPE” Krepeli. Needless to say, their lifestyles clash. Jerms does his best to spend as little time around Krepe as possible. He has been considering moving out for months, but doesn’t want to let down his roommates down."
    />

    <h2 style={{ textAlign: 'center' }}>Mario "KREPE" Krepeli</h2>
    <Block
      image="/krepe.jpg"
      paragraphs="Born in Gainsville, Florida but raised all over the country, Krepe eventually ended up in New York where he attended Fordham University and created his own major of Taste Testing. He is the only child of a surgeon and a litigator, yet was often left alone, disabling him from having any relationship with anyone in his life (friendship or intimate). He is the true definition of a loner, addicted to video games and pornography (magazines, not that internet junk). He met his roommate Steve, while searching for an apartment on craigslist. When Steve realized that the two could not afford the apartment, Dr. Jeremy &quot;JERMS&quot; Madison moved in to pick up the slack. Krepe doesn't have any issues with his roommates because he simply lacks any motivation to care about anything or anyone, but time could change that."
    />

    <h2 style={{ textAlign: 'center' }}>The Shorts Show</h2>
    <Block
      image="/ShortsShow1.jpg"
      paragraphs="The Shorts Show is a production company that originated as a sketch comedy group in 2010. Although they have more recently produced music videos and short films, The Shorts Show continues to strive towards making audiences laugh, adding new sketches to their website frequently. It was founded by Corey Scott Rutledge, who served as executive producer on Bumbloods. Without this collaboration, Bumbloods would not have been possible."
    />
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/About.js